import SpeakerHeader from './SpeakerHeader';

export default SpeakerHeader;
